// extracted by mini-css-extract-plugin
export default {"img":"ProductsRow_img__1CL0R","article":"ProductsRow_article__2QA60"};